import userInterface from './reducers';

export { default as UIOperations } from './operations';
export { default as UISelectors } from './selectors';
export { MenuItem } from './actions';

export default userInterface;
